function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createErrorWithType } from '@apiEnabler/api-enabler-common/lib/errors';
import createCommonRequest$ from '@apiEnabler/api-enabler-common/lib/request';
import { flatMap, map } from 'rxjs/operators';
import { authToken$ } from './url-params';
export var statusToError = {
  404: function toNotFoundError(xhr) {
    return createErrorWithType("Request to ".concat(xhr.responseURL, " returned not found"), 'not-found');
  },
  403: function toInsufficientPermissionsError(xhr) {
    var customerType = getCustomerType(xhr.responseURL);
    return createErrorWithType("Insufficient permissions for call to ".concat(xhr.responseURL), ['insufficient-permissions', customerType].filter(function (i) {
      return !!i;
    }).join('-'));
  },
  401: function toUnauthorizedError(xhr) {
    return createErrorWithType("Unauthorized call to ".concat(xhr.responseURL), 'token-expired');
  },
  422: function toUnprocessableEntityError(xhr) {
    var response = parseResponse(xhr.response);
    return createErrorWithType(response.message || xhr.statusText, "".concat(response.code), response);
  }
};
var accessHeaders$ = authToken$.pipe(map(function (token) {
  return {
    Accept: 'application/json',
    Authorization: "Bearer ".concat(token)
  };
}));
export default function createRequest$(endpoint) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var body = arguments.length > 2 ? arguments[2] : undefined;
  var params = arguments.length > 3 ? arguments[3] : undefined;
  var responseTimeCallback = arguments.length > 4 ? arguments[4] : undefined;
  return accessHeaders$.pipe(map(addIAMClaimsetJWT), flatMap(function (headers) {
    return createCommonRequest$(endpoint, method, body, params, headers, statusToError, responseTimeCallback);
  }));
}
function addIAMClaimsetJWT(headers) {
  var iamClaimsetJWT = process.env.REACT_APP_IAM_CLAIMSET_JWT;
  if (iamClaimsetJWT) headers['iam-claimsetjwt'] = iamClaimsetJWT;
  return headers;
}
function getCustomerType(url) {
  var _url$split = url.split('customerType='),
    _url$split2 = _slicedToArray(_url$split, 2),
    customerTypeAndRest = _url$split2[1];
  return customerTypeAndRest ? customerTypeAndRest.split('&')[0] : null;
}
function parseResponse(response) {
  try {
    return JSON.parse(response);
  } catch (e) {
    return response;
  }
}